import { LinkProps } from '../../components/HelpPages/atoms/Link';

export const mapToLinkProps = (
	icon?: string | null,
	title?: string | null,
	link?: string | null,
): LinkProps => {
	const result: LinkProps = {
		label: title || '',
		url: link || '',
		// todo - project specific text to icon mapping
		icon: icon && <span className={'text-white text-[20px] ' + icon} />,
	};

	return result;
};
